import { ENDPOINT_REDIRECT } from "utils/constants";
import { axiosInstance } from "./servicesSetup";

export const getRedirectToken = async () => {
  const instance = await axiosInstance();
  return instance.post(ENDPOINT_REDIRECT, {
    withCredentials: true
  });
};
